function getParentFormField(element) {
    if (element.parentNode.classList.contains('form__field')) {
        return element.parentNode;
    }

    return element.parentNode.parentNode;
}

export function hidePlaceholder(element) {
    getParentFormField(element).classList.add('has-value');
}

export function showPlaceholder(element) {
    getParentFormField(element).classList.remove('has-value');
}

export function togglePlaceholder(element) {
    if (element.value.length) {
        hidePlaceholder(element);
    } else if (!element.hasAttribute('placeholder')) {
        showPlaceholder(element);
    }
}

export function init(root = document) {
    root.querySelectorAll('label + input[placeholder], label + select, label + textarea[placeholder]').forEach(element => {
        hidePlaceholder(element);
    });

    root.querySelectorAll('label + input, label + textarea').forEach(element => {
        element.addEventListener('input', event => {
            togglePlaceholder(event.target);
        });
    });
}
